var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.724,
    height: 40.003,
    viewBox: "0 0 40.724 40.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-178.013 -907.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(178.013 907.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M192.95,907.967v3.3H178.013V947.97H206.4v-3.3h14.873V907.967Z",
    transform: "translate(-178.013 -907.967)",
    fill: "#2d2eb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M209.223,932.473h-6.547l4.63-4.63-2.4-2.4-4.63,4.63v-6.547h-3.4v6.547l-4.63-4.63-2.4,2.4,4.63,4.63h-6.547v3.4h6.547l-4.63,4.63,2.4,2.4,4.63-4.63v6.547h3.4v-6.547l4.63,4.63,2.4-2.4-4.63-4.63h6.547Z",
    transform: "translate(-181.966 -914.17)",
    fill: "#ff3e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M219.546,938.272v6.547h3.4v-6.547l4.63,4.63,2.4-2.4-4.63-4.63h6.547v-3.4h-6.547l4.63-4.63-2.4-2.4-4.63,4.63v-6.547h-3.4v14.748Z",
    transform: "translate(-194.574 -914.17)",
    fill: "#ff3e00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.26de04d56aa49e08a768103ba6d07690.svg";
export { ForwardRef as ReactComponent };